import { Text } from "@chakra-ui/react";
import { memo } from "react";
import { NoFieldPreviewProps } from "../fields/types";

const NoFieldPreview = (props: NoFieldPreviewProps) => {
  const { index, prevItemResultCount, allItemResultCount } = props;

  if (!allItemResultCount) {
    return <></>;
  }

  return (
    <Text flexShrink={0} letterSpacing="2px" fontSize="1.2rem" fontWeight={400}>
      <Text as="b" fontSize="1.6rem">
        {prevItemResultCount + index + 1}
      </Text>
      /{`${allItemResultCount}:`}
    </Text>
  );
};

export default memo(NoFieldPreview);
